import React, { useState } from 'react';
import styled from 'styled-components';

const EventListStyle = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  padding-left: 0;
`;

const CatListStyle = styled.ul`
  list-style: none;
  display: flex;
  padding-left: 0;
`;

const CatItem = styled.li`
  margin: 0.2rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
`;

export const EventList = ({ list, searchText }) => {
  const isBoost = window.ASC_IS_BOOST;

  const setCatDefaults = () => {
    const catArray = [];
    list.categories.forEach(() => catArray.push(false));
    return catArray;
  };

  const catFilter = ({ categories }) => {
    if (!isCatSelected.some((val) => val)) {
      return true;
    }
    const activeFilters = [];
    list.categories.reduce((activeFilters, cat, index) => {
      if (isCatSelected[index]) activeFilters.push(cat.slug);
      return activeFilters;
    }, activeFilters);
    return categories.some(({ slug }) => {
      return activeFilters.indexOf(slug) >= 0;
    });
  };

  const textFilter = ({ title }) => {
    if (!searchText.length) return true;
    return title.toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
  };

  const filterBySite = ({ hideOnJoy, hideOnBoost }) => {
    if (isBoost) {
      return !hideOnBoost;
    } else {
      return !hideOnJoy;
    }
  };

  const dateSort = (a, b) => {
    if (a.startTime < b.startTime) {
      return -1;
    } else if (a.startTime > b.startTime) {
      return 1;
    }
    return 0;
  };

  const isFeatured = (cats) => {
    return cats.some((cat) => cat.slug === 'featured');
  };

  const [isCatSelected, setIsCatSelected] = useState(setCatDefaults());

  const toggleCat = (index) => {
    const newArray = isCatSelected.concat();
    newArray[index] = !isCatSelected[index];
    setIsCatSelected(newArray);
  };

  const formatDates = (start, end) => {
    const sDate = new Date(start);
    const eDate = end ? new Date(end) : sDate;

    const MONTHS = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    if (sDate.getMonth() === eDate.getMonth()) {
      if (sDate.getDate() === eDate.getDate()) {
        return (
          <>
            <span className='month'>{MONTHS[sDate.getMonth()]}</span>
            <span className='spacer'> </span>
            <span className='day'>{sDate.getDate()}</span>
          </>
        );
      } else {
        return (
          <>
            <span className='month'>{MONTHS[sDate.getMonth()]}</span>
            <span className='spacer'> </span>
            <span className='day'>{sDate.getDate()}</span>
            <span className='dash'>-</span>
            <span className='day'>{eDate.getDate()}</span>
          </>
        );
      }
    } else {
      return (
        <>
          <span className='month'>{MONTHS[sDate.getMonth()]}</span>
          <span className='spacer'> </span>
          <span className='day'>{sDate.getDate()}</span>
          <span className='dash'>-</span>
          <span className='month'>{MONTHS[eDate.getMonth()]}</span>
          <span className='day'>{eDate.getDate()}</span>
        </>
      );
    }
  };

  return (
    <div>
      <CatListStyle className='asc-event-cat-list'>
        {list.categories
          .filter((cat, index, self) => {
            return index === self.findIndex((obj) => obj.slug === cat.slug);
          })
          .map(({ name, slug }, index) => (
            <CatItem
              key={slug}
              onClick={(e) => {
                e.preventDefault();
                toggleCat(index);
              }}
              className={`asc-event-cat-item ${
                isCatSelected[index] ? 'selected' : ''
              }`}
            >
              {name.replace('&amp;', '&')}
            </CatItem>
          ))}
      </CatListStyle>
      <EventListStyle className={`event-list-${list.id.toLowerCase()}`}>
        {list.events
          .filter(filterBySite)
          .filter(catFilter)
          .filter(textFilter)
          .sort(dateSort)
          .map(
            ({
              title,
              startTime,
              endTime,
              description,
              signupLink,
              eventLink,
              imageUrl,
              address,
              categories,
            }) => (
              <React.Fragment key={eventLink}>
                {isBoost ? (
                  <a
                    href={eventLink}
                    className={`block list-item ${
                      imageUrl ? 'image-event-link ' : ''
                    }${isFeatured(categories) ? 'featured ' : ''}event-link`}
                  >
                    {imageUrl && (
                      <img
                        src={imageUrl[0]}
                        alt={`${title}`}
                        className='event-image'
                      />
                    )}
                    <div className='info'>
                      <span className='title'>{title}</span>
                      <div className='event-info'>
                        <span className='start-date'>
                          {formatDates(startTime, endTime)}
                        </span>
                        {address && (
                          <div
                            className='address'
                            dangerouslySetInnerHTML={{ __html: address }}
                          />
                        )}
                      </div>
                      {/* <div className='description'>{description}</div>
                      <a href={signupLink || eventLink} class='link'>
                        Details
                      </a> */}
                    </div>
                  </a>
                ) : (
                  <div
                    className={`block list-item ${
                      imageUrl ? 'image-event-link ' : ''
                    }${isFeatured(categories) ? 'featured ' : ''}event-link`}
                  >
                    {imageUrl && (
                      <img
                        src={imageUrl[0]}
                        alt={`${title}`}
                        className='event-image'
                      />
                    )}
                    <div className='info'>
                      <span className='start-date'>
                        {formatDates(startTime, endTime)}
                      </span>
                      <span className='title'>{title}</span>
                      <div
                        className='description'
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                      <a href={eventLink} className='link'>
                        Details
                      </a>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )
          )}
      </EventListStyle>
    </div>
  );
};
